import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Accordion, AccordionProps, AccordionSummary, Typography } from '@mui/material';

/**
 * A custom Accordion component that uses a plus icon when collapsed and a minus icon when expanded. It also accepts a title prop to display as the accordion summary.
 * NOTE: It already comes with an Accordion Summary.
 */
export const PlusAccordion = ({ summary, ...props }: AccordionProps & { summary: React.ReactNode }) => {
    return (
        <Accordion {...props}>
            <AccordionSummary
                expandIcon={props.expanded ? <RemoveIcon /> : <AddIcon />}
                className="border-b border-solid border-[#D3D2CC]"
            >
                <Typography fontFamily="museo-sans" fontSize={26} letterSpacing={-1} py="26px">
                    {summary}
                </Typography>
            </AccordionSummary>
            {props.children}
        </Accordion>
    );
};
